import { ClassificaGescorVO } from "./classifica-gescorVO";
import { DocumentoGescorVO } from "./documento-gescorVO";
import { MetadatiProtocolloGescorVO } from "./metadati-protocollo-gescorVO";

export class CorrispondenzaArrivoVO {
  oggetto: string;

  primario: DocumentoGescorVO;

  allegati: DocumentoGescorVO[];

  classifica: ClassificaGescorVO[] = new Array<ClassificaGescorVO>();

  classificaInterna: ClassificaGescorVO = new ClassificaGescorVO();

  riservata: Boolean;

  metadatiProtocollo: MetadatiProtocolloGescorVO;
}
